// Used in the consults section to initialize the input mask for the appointment date field, will need to refactor.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    InputMask.init()  
  }

}